import React, { useEffect, useState } from 'react';
import { Table, Button, Form, InputGroup, Col, Row } from 'react-bootstrap';
import { adminInstance } from '../services/axiosInstance'; 
import Select from 'react-select';

const CheckoutPage = () => {
  const [customer, setCustomer] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [cartItems, setCartItems] = useState([]);
  const [userComment, setUserComment] = useState('');
  const [isNewCustomer, setIsNewCustomer] = useState(false);
  const [newCustomer, setNewCustomer] = useState({
    CusCode: '',
    CusName: '',
    CusAddress: '',
    CusGSTIN: '',
    CusContact: '',
    CusState: ''
  });
  const states = [
    { label: "Andhra Pradesh", value: "Andhra Pradesh" },
    { label: "Arunachal Pradesh", value: "Arunachal Pradesh" },
    { label: "Assam", value: "Assam" },
    { label: "Bihar", value: "Bihar" },
    { label: "Chhattisgarh", value: "Chhattisgarh" },
    { label: "Goa", value: "Goa" },
    { label: "Gujarat", value: "Gujarat" },
    { label: "Haryana", value: "Haryana" },
    { label: "Himachal Pradesh", value: "Himachal Pradesh" },
    { label: "Jharkhand", value: "Jharkhand" },
    { label: "Karnataka", value: "Karnataka" },
    { label: "Kerala", value: "Kerala" },
    { label: "Madhya Pradesh", value: "Madhya Pradesh" },
    { label: "Maharashtra", value: "Maharashtra" },
    { label: "Manipur", value: "Manipur" },
    { label: "Meghalaya", value: "Meghalaya" },
    { label: "Mizoram", value: "Mizoram" },
    { label: "Nagaland", value: "Nagaland" },
    { label: "Odisha", value: "Odisha" },
    { label: "Punjab", value: "Punjab" },
    { label: "Rajasthan", value: "Rajasthan" },
    { label: "Sikkim", value: "Sikkim" },
    { label: "Tamil Nadu", value: "Tamil Nadu" },
    { label: "Telangana", value: "Telangana" },
    { label: "Tripura", value: "Tripura" },
    { label: "Uttar Pradesh", value: "Uttar Pradesh" },
    { label: "Uttarakhand", value: "Uttarakhand" },
    { label: "West Bengal", value: "West Bengal" },
    { label: "Andaman and Nicobar Islands", value: "Andaman and Nicobar Islands" },
    { label: "Chandigarh", value: "Chandigarh" },
    { label: "Dadra and Nagar Haveli and Daman and Diu", value: "Dadra and Nagar Haveli and Daman and Diu" },
    { label: "Delhi", value: "Delhi" },
    { label: "Jammu and Kashmir", value: "Jammu and Kashmir" },
    { label: "Ladakh", value: "Ladakh" },
    { label: "Lakshadweep", value: "Lakshadweep" },
    { label: "Puducherry", value: "Puducherry" }
  ];

  useEffect(() => {
    loadCartItems();
    loadCustomer();
  }, []);

  const loadCartItems = () => {
    const storedItems = JSON.parse(sessionStorage.getItem('CartItems')) || [];
    setCartItems(storedItems);
  }

  const loadCustomer = async () => {
        try {
            const response = await adminInstance.get(`Dashboard/GetCustomer`);
            debugger;
            setCustomer(response.data.customers || []);
        } catch (error) {
            console.error('Error fetching orders:', error.message);
        } finally {
            console.log('Fetch process completed.');
        }
    };

  const updateQuantity = (ItemCode, change) => {
    setCartItems(prev =>
      prev.map(item =>
        item.ItemCode === ItemCode
          ? { ...item, quantity: Math.max(1, item.quantity + change) }
          : item
      )
    );
  };

  const removeItem = (id) => {
    debugger;
    setCartItems(prev => prev.filter(item => item.ItemCode !== id));
    sessionStorage.setItem('CartItems', JSON.stringify(cartItems.filter(item => item.ItemCode !== id)));
  };

  const handleClearCart = () => {
    setCartItems([]);
    sessionStorage.setItem('CartItems', JSON.stringify([]));
  };

  const handleCheckout = async () => {
    if (cartItems.length === 0) {
      alert('Cart is empty!');
      return;
    }

    if(isNewCustomer){
      if(newCustomer.CusCode.length === 0 || newCustomer.CusAddress.length === 0 || newCustomer.CusContact.length === 0 || newCustomer.CusGSTIN.length === 0 
        || newCustomer.CusName.length === 0 || newCustomer.CusState.length === 0 ){
        alert("Please enter all the new customer details and try again!");
        return false;
      }
    }
    else if (!selectedCustomer ||  selectedCustomer.length === 0) {
      alert('Please select customer and try again !');
      return;
    }

    debugger;
    try {
      var obj = {
        Request : {
          CUS_CODE: selectedCustomer,
          USER_COMMENT: userComment,
          NEW_CUSTOMER: JSON.stringify(newCustomer)
        },
        Items: []
      };
      cartItems.map(itm => {
        obj.Items.push({ITEM_CODE: itm.ItemCode, QTY: itm.quantity});
      })
      await adminInstance.post('/quoterequest/save', obj);
      sessionStorage.removeItem('CartItems');
      setCartItems([]);
      alert('Request Sent successfully!');      
    } catch (err) {
      alert('Request failed. Please try again.');
    }
  };

  const handleCustomerChange = (option) => {
    setSelectedCustomer(option ? option.CusCode : null);
    console.log('Selected customer ID:', option?.CusCode);
  };

  const total = cartItems.reduce(
    (acc, item) => acc + item.quantity,
    0
  );

  return (
    <div className="card aon-card">
    <div className="card-header aon-card-header">
        <h4>
            Checkout
        </h4>
    </div>
    <div className="card-body aon-card-body">
        <div className="container mt-4">
        <h3>Send Quotation Request</h3>
        {cartItems.length === 0 ? (
            <p>Your cart is empty.</p>
        ) : (
            <>
            <Row>
            <Col md={12}>

            
            {/* <div style={{  marginBottom: '20px'  }}>
              <label><strong>Select customer</strong></label>
              <Select
                options={customer}
                getOptionLabel={(e) => `${e.CusName} (${e.CusState})`}
                getOptionValue={(e) => e.CusCode}
                //value={selectedCustomer}
                onChange={handleCustomerChange}
                isClearable
                placeholder="Choose customer..."
              />
            </div> */}

            {isNewCustomer ? (
              <Row>
                <Col md={6}>
                  <Form.Group controlId="CusCode" className="mb-2">
                    <Form.Label>Customer Code</Form.Label>
                    <Form.Control
                      type="text"
                      value={newCustomer.CusCode}
                      onChange={(e) => setNewCustomer({ ...newCustomer, CusCode: e.target.value })}
                    />
                  </Form.Group>
                  <Form.Group controlId="CusName" className="mb-2">
                    <Form.Label>Customer Name</Form.Label>
                    <Form.Control
                      type="text"
                      value={newCustomer.CusName}
                      onChange={(e) => setNewCustomer({ ...newCustomer, CusName: e.target.value })}
                    />
                  </Form.Group>
                  <Form.Group controlId="CusAddress" className="mb-2">
                    <Form.Label>Address</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={2}
                      value={newCustomer.CusAddress}
                      onChange={(e) => setNewCustomer({ ...newCustomer, CusAddress: e.target.value })}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group controlId="CusGSTIN" className="mb-2">
                    <Form.Label>GSTIN</Form.Label>
                    <Form.Control
                      type="text"
                      value={newCustomer.CusGSTIN}
                      onChange={(e) => setNewCustomer({ ...newCustomer, CusGSTIN: e.target.value })}
                    />
                  </Form.Group>
                  <Form.Group controlId="CusContact" className="mb-2">
                    <Form.Label>Contact Person</Form.Label>
                    <Form.Control
                      type="text"
                      value={newCustomer.CusContact}
                      onChange={(e) => setNewCustomer({ ...newCustomer, CusContact: e.target.value })}
                    />
                  </Form.Group>
                  <Form.Group controlId="CusState">
                    <Form.Label>State</Form.Label>
                    <Form.Control
                      as="select"
                      name="CusState"
                      value={newCustomer.CusState}
                      onChange={(e) => setNewCustomer({ ...newCustomer, CusState: e.target.value })}
                    >
                      <option value="">Select State</option>
                      {states && states.map((group) => (
                        <option key={group.value} value={group.value}>
                          {group.label}
                        </option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                </Col>
              </Row>
            ) : (
              <Select
                options={customer}
                getOptionLabel={(e) => `${e.CusCode}, ${e.CusName}, (${e.CusAddress}, ${e.CusCity})`}
                getOptionValue={(e) => e.CusCode}
                onChange={handleCustomerChange}
                isClearable
                placeholder="Choose customer..."

                menuPortalTarget={document.body}
                styles={{
                    menuPortal: (base) => ({
                        ...base,
                        zIndex: 9999
                    })
                }}
              />
            )}
            </Col>
            <Col>
            <div  style={{ width: '100%', marginBottom: '20px'  }}>
                <Form.Group controlId="notes">
                    <Form.Label>User Notes</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      name="notes"
                      value={userComment}
                      onChange={(e) => setUserComment(e.target.value)}
                      onBlur={(e) => setUserComment(e.target.value)}
                    />
                  </Form.Group>
            </div>
            </Col>
            </Row>
            <Table bordered hover responsive>
                <thead>
                <tr>
                    <th>Item Code</th>
                    <th>Item Name</th>
                    <th style={{ width: '180px', minWidth: '180px' }}>Quantity</th>                    
                    <th>Action</th>
                </tr>
                </thead>
                <tbody>
                {cartItems.map(item => (
                    <tr key={item.ItemCode}>
                    <td>{item.ItemCode}</td>
                    <td>{item.ItemName}</td>
                    <td>
                        <InputGroup>
                        <Button
                            variant="outline-secondary"
                            size="sm"
                            onClick={() => updateQuantity(item.ItemCode, -1)}
                        >
                            -
                        </Button>
                        <Form.Control
                            value={item.quantity}
                            readOnly
                            style={{ textAlign: 'center', minWidth: '60px', paddingLeft: 4, paddingRight: 4 }}
                        />
                        <Button
                            variant="outline-secondary"
                            size="sm"
                            onClick={() => updateQuantity(item.ItemCode, 1)}
                        >
                            +
                        </Button>
                        </InputGroup>
                    </td>
                    <td>
                        <Button
                        variant="danger"
                        size="sm"
                        onClick={() => removeItem(item.ItemCode)}
                        >
                        Remove
                        </Button>
                    </td>
                    </tr>
                ))}
                <tr>
                    <td colSpan={2} className="text-end fw-bold">Total Quantity</td>
                    <td colSpan={2} className="fw-bold">{total}</td>
                </tr>
                </tbody>
            </Table>

            

            <Button variant="primary" onClick={handleCheckout} style={{"marginRight": 20}}>
                Send Quotation Request
            </Button>
            <Button variant="warning" onClick={handleClearCart}>
                Clear Cart
            </Button>
            </>
        )}
        </div>
    </div>
    </div>
  );
};

export default CheckoutPage;
